const TOTAL_MAX_CHARS = 16384
const PROMPT_CHARS = 1337

export const HOTMART_AI_CONFIG = {
  prompt: 'community_engagement_comment_suggestion',
  max_chars: TOTAL_MAX_CHARS - PROMPT_CHARS
}

export const LANGUAGES = {
  en: 'english',
  'pt-br': 'portuguese',
  es: 'spanish',
  fr: 'french'
}
